import React from 'react'



// components
// import MainBanner from './MainBanner'
// import News from '../../pages/News/News'
// import TourItems from '../../pages/Tour/TourItems'
// import Tracks from '../../pages/Tracks/Tracks'
// import ShopBanner from './ShopBanner'
// import TourBanner from './TourBanner'

const Home = () => {
	return (
		<main className="main">
			{/* <MainBanner />
			<TourItems />
			<TourBanner />
			<Tracks />
			<ShopBanner />
			<News /> */}
		</main>
	)
}

export default Home